/* global CHUI */
import HUI from 'barracuda-ui';
import { observe as getAuthObservable } from 'barracuda-chui/auth';
import Tools from 'barracuda-ui/tools';
import Events from 'barracuda-ui/events';
import CHUIAPI from 'barracuda-chui/api';
import HUINav from 'barracuda-ui/nav';
import getCookies from 'lib/util/getCookies';
import i18n from 'lib/i18n';

import {
	BCC_NAV_LABEL_ADMIN,
	BCC_NAV_LABEL_USERS,
	BCC_NAV_LABEL_DIRECTORIES,
	BCC_NAV_LABEL_GROUPS,
	BCC_NAV_LABEL_OPTIONS,
	BCC_NAV_LABEL_AUDIT_LOG,
	BCC_NAV_LABEL_ESSENTIALS,
	BCC_NAV_LABEL_PARTNER,
	BCC_NAV_LABEL_CUSTOMER_ACCOUNTS,
	BCC_NAV_LABEL_APPLIANCE_CONTROL_MANAGEMENT,
	BCC_NAV_LABEL_SAML_METADATA,
} from './lids';

// TODO: remove this after CHUI is full-time BNPL-10528
const USE_CHUI =
	// check for a cookie
	getCookies().get('USE_CHUI')
		? +getCookies().get('USE_CHUI')
		: // check for prop on window
		Object.prototype.hasOwnProperty.call(global, 'USE_CHUI')
		? global.USE_CHUI
		: // else check env var
		  process.env.USE_CHUI === 'true';
const Nav = USE_CHUI ? CHUIAPI : HUINav;

// load i18n messages for the wrapper (lazily)
i18n.addMessagesLoader(function wrapperMessagesLoader(locale) {
	log.debug('fetching wrapper lids for locale', locale);
	if (locale === 'en_US') {
		return import(
			/*
			webpackMode: "eager",
			webpackChunkName: "wrapper-messages-[request]",
			webpackInclude: /en_US/
			*/
			`@barracuda-internal/messages-webpack-loader?{key:'wrapper',exportsOf:'src/boot/lids'}!../../node_modules/@barracuda-internal/commondata-locale/locale/${locale}/messages.txt`
		);
	}
	return import(
		/*
			webpackMode: "lazy",
			webpackChunkName: "wrapper-messages-[request]",
			webpackExclude: /en_US/
			*/
		`@barracuda-internal/messages-webpack-loader?{key:'wrapper',exportsOf:'src/boot/lids'}!../../node_modules/@barracuda-internal/commondata-locale/locale/${locale}/messages.txt`
	);
});

// Load messages into OLD HUI WRAPPER
HUI.Exports.i18n.addMessagesLoader((locale) => {
	let result = {};
	try {
		// eslint-disable-next-line import/no-dynamic-require, global-require
		result = require(`@barracuda-internal/messages-webpack-loader?{key:'wrapper',exportsOf:'src/boot/lids'}!../../node_modules/@barracuda-internal/commondata-locale/locale/${locale}/messages.txt`);
	} catch (e) {
		log.info('Could not fetch messages for', locale);
	}
	return result;
});

const removeProtocol = (url) => url.replace(/^https?:\/\//, '');

const getAPIPerm = (auth, key) => {
	// HACK
	// TODO: fix in bcc api
	// this key is always undefined when it means false :(
	if (key === 'is_msp' && auth[key] === undefined) {
		auth[key] = false;
	}

	if (auth[key] === undefined) {
		log.warn(new Error(`Missing permission for '${key}', failing closed.`));
		return false;
	}

	// use JSON.parse because we get strings of "true" or "false"
	return JSON.parse(auth[key]);
};

// eslint-disable-next-line complexity, max-statements
const twiddleTabs = (auth) => {
	// permission values
	const perms = {
		has_billing_admin: getAPIPerm(auth, 'has_billing'),
		has_user_admin: getAPIPerm(auth, 'has_admin'),
		not_msp_partner: !getAPIPerm(auth, 'is_msp_partner'),
		is_reseller: getAPIPerm(auth, 'is_reseller'),
	};

	// for convenience
	perms.billing_or_user = perms.has_billing_admin || perms.has_user_admin;

	// Top level tabs: logic translated from nav_hui.php
	if (perms.not_msp_partner && perms.billing_or_user && perms.is_reseller) {
		Nav.showTabs(['admin', 'support']);
	} else if (perms.not_msp_partner && perms.billing_or_user && !perms.is_reseller) {
		Nav.showTabs(['admin']);
		Nav.hideTabs(['support']);
	} else {
		Nav.hideTabs(['admin', 'support']);
	}

	// Admin subtabs: logic translated from Auth.php
	Nav.hideTabs([
		'nav-account-user',
		'nav-account-directory',
		'nav-account-group',
		'nav-account-options',
		'nav-account-auditing',
		'nav-account-office365',
		'nav-account-saml',
	]);

	if (perms.has_user_admin) {
		Nav.showTabs([
			'nav-account-user',
			'nav-account-directory',
			'nav-account-group',
			'nav-account-options',
			'nav-account-auditing',
			'nav-account-saml'
		]);
	}

	if (perms.has_user_admin && perms.not_msp_child) {
		Nav.showTabs(['nav-account-options', 'nav-account-auditing', 'nav-account-office365']);
	}
};

// TODO: simplify this after CHUI is full-time BNPL-10528
if (USE_CHUI) {
	getAuthObservable('bcc').subscribe((auth) => {
		if (!auth.loading && !auth.error) {
			twiddleTabs(auth);
		}
	});
} else {
	// twiddle on auth
	Tools.auth().then((auth) => {
		twiddleTabs(auth);
	});

	// twiddle if account id changes
	Events.addEventListener('accountSelectionChange', () => {
		Tools.auth().then((auth) => {
			twiddleTabs(auth);
		});
	});
}

try {
	const BCC_URL = process.env.BCC_URL;
	const API_URL = process.env.API_URL;
	const COOKIE_DOMAIN = process.env.COOKIE_DOMAIN;

	const removeIsFromPropNames = (tab) => {
		// TODO: rework this after CHUI is full-time BNPL-10528
		if (USE_CHUI) {
			Object.keys(tab).forEach((p) => {
				const matches = p.match(/^is([A-Z])(.*)/);
				if (matches) {
					tab[`${matches[1].toLowerCase()}${matches[2]}`] = tab[p];
				}
			});
		}
		return tab;
	};
	const selectify = (tab) => {
		const loc = global.location;
		return removeIsFromPropNames({
			...tab,
			isSelected: tab.exact ? loc.pathname === tab.href : loc.pathname.indexOf(tab.href) === 0,
		});
	};

	let wrapper;
	const tabs = [
		selectify({
			id: 'admin',
			isHidden: true,
			label: 'Admin',
			href: `${BCC_URL}/account/`,
			lid: BCC_NAV_LABEL_ADMIN,
			exact: true,
			childItems: [
				selectify({
					id: 'nav-account-user',
					isHidden: true,
					label: 'Users',
					href: `${BCC_URL}/account/user/`,
					lid: BCC_NAV_LABEL_USERS,
				}),
				selectify({
					id: 'nav-account-directory',
					isHidden: true,
					label: 'Directories',
					href: '/account/directory/',
					lid: BCC_NAV_LABEL_DIRECTORIES,
				}),
				selectify({
					id: 'nav-account-group',
					isHidden: true,
					label: 'Groups',
					href: `${BCC_URL}/account/group/`,
					lid: BCC_NAV_LABEL_GROUPS,
				}),
				selectify({
					id: 'nav-account-options',
					isHidden: true,
					label: 'Options',
					href: `${BCC_URL}/account/options/`,
					lid: BCC_NAV_LABEL_OPTIONS,
				}),
				selectify({
					id: 'nav-account-auditing',
					isHidden: true,
					label: 'Audit Log',
					href: `${BCC_URL}/account/auditing/`,
					lid: BCC_NAV_LABEL_AUDIT_LOG,
				}),
				selectify({
					id: 'nav-account-office365',
					isHidden: true,
					label: 'Essentials',
					href: `${BCC_URL}/account/essentials/`,
					lid: BCC_NAV_LABEL_ESSENTIALS,
				}),
				selectify({
					id: 'nav-account-saml',
					isHidden: true,
					label: 'SAML',
					href: `/account/saml/`,
					lid: BCC_NAV_LABEL_SAML_METADATA,
				}),
			],
		}),
		selectify({
			id: 'support',
			isHidden: true,
			label: 'Partner',
			href: `${BCC_URL}/account/partner/`,
			lid: BCC_NAV_LABEL_PARTNER,
			childItems: [
				selectify({
					id: 'nav-account-partner-customers',
					label: 'Customer Accounts',
					href: `${BCC_URL}/partner/customers/`,
					lid: BCC_NAV_LABEL_CUSTOMER_ACCOUNTS,
				}),
				selectify({
					id: 'nav-account-partner-devices',
					label: 'Appliance Control Management',
					href: `${BCC_URL}/partner/devices/`,
					lid: BCC_NAV_LABEL_APPLIANCE_CONTROL_MANAGEMENT,
				}),
			],
		}),
	];

	if (USE_CHUI) {
		CHUI.Config.set({
			BCC_URL,
			BCC_SOAP_API_URL: `${BCC_URL}/api/soap`,
			BCC_API_URL: API_URL,
			COOKIE_DOMAIN,
		});

		wrapper = CHUI.API.initializeWrapper({
			serviceId: 'bcc',
			serviceTitle: 'Cloud Control',
			navigationTabs: tabs,
			showNavigation: true,
		});
	} else {
		wrapper = new HUI.Components.Wrapper({
			id: 'raft.bcc.wrapper',
			container: '#wrapper',
			contentArea: '#contentArea',
			productTitle: 'Cloud Control',
			urls: {
				// HUI doesn't like protocols on its hostnames/urls
				bcc: removeProtocol(BCC_URL),
				bcc_soap: removeProtocol(BCC_URL),
			},
			tabs,
		});
	}
	wrapper.render();
} catch (e) {
	log.warn(e);
}
